export default __webpack_public_path__ + "static/media/author.68292ea7.svg";